// @flow
import React, { useState, useRef, useEffect } from 'react'
import classnames from 'classnames'
import { EditorState, convertFromRaw, ContentState } from 'draft-js'

import createEmojiPlugin from '@draft-js-plugins/emoji'
import createLinkifyPlugin from '@draft-js-plugins/linkify'
import Editor from '@draft-js-plugins/editor'
// import createMentionPlugin, { defaultSuggestionsFilter } from '@draft-js-plugins/mention'

// import '@draft-js-plugins/emoji/lib/plugin.css'
// import '@draft-js-plugins/mention/lib/plugin.css'

import styles from './comment.module.scss'
// import mentionsStyles from './mention.scss'

// @TODO mentions must be request
// const suggestions = [
//   {
//     id: 'adfdar',
//     username: 'mat',
//     name: 'Matthew Russell',
//     link: 'https://twitter.com/mrussell247',
//     avatar: 'https://pbs.twimg.com/profile_images/517863945/mattsailing_400x400.jpg',
//   },
//   {
//     id: 'fdagfae',
//     username: 'julian',
//     name: 'Julian Krispel-Samsel',
//     link: 'https://twitter.com/juliandoesstuff',
//     avatar: 'https://avatars2.githubusercontent.com/u/1188186?v=3&s=400',
//   },
// ]

interface Props {
  className?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  comment: any
  readOnly?: boolean
  placeholder?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (e: any) => void
}

const CommentEditor = ({
  className = '',
  comment,
  readOnly = false,
  placeholder = 'Write a public comment...',
  onChange = (f) => f,
}: Props) => {
  let initState
  if (!comment) {
    initState = EditorState.createEmpty()
  }
  else if (typeof comment !== 'string') {
    initState = EditorState.createWithContent(convertFromRaw(comment))
  }
  else {
    initState = EditorState.createWithContent(
      ContentState.createFromText(comment),
    )
  }

  const [ editorState, setEditorState ] = useState(initState)
  const [ isFocus, setFocus ] = useState(false)
  const editorRef = useRef<Editor>(null)
  const linkifyPlugin = useRef(createLinkifyPlugin())
  const emojiPlugin = useRef(createEmojiPlugin())

  const plugins = [
    linkifyPlugin.current,
    emojiPlugin.current,
    // mentionPlugin,
  ]

  const onChangeText = (state) => {
    const contentState = state.getCurrentContent()
    const plainText = contentState.getPlainText()

    setEditorState(state)

    // estract mentions
    // const mentions = Object.keys(raw.entityMap)
    //   .map(k => raw.entityMap[k])
    //   .filter(content => content.type === 'mention')
    //   .map(content => content.data.mention)
    // console.log(mentions)

    onChange(plainText)
  }

  // onSearchChange = ({ value }) => {
  //   this.setState({
  //     suggestions: defaultSuggestionsFilter(value, suggestions),
  //   })
  // }

  // const onAddMention = () => {
  //   // get the mention object selected
  // }

  const onFocus = () => setFocus(true)
  const onBlur = () => setFocus(false)

  // const { MentionSuggestions } = mentionPlugin.current
  const { EmojiSuggestions } = emojiPlugin.current

  useEffect(() => {
    if (!comment) {
      const newEditorState = EditorState.push(editorState, ContentState.createFromText(''), 'remove-range')
      setEditorState(newEditorState)
      setTimeout(() => {
        editorRef.current?.forceUpdate()
      }, 100)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ comment ])

  return (
    <div
      className={classnames(styles.editor, className, {
        [styles.focus]: isFocus,
        [styles.readOnly]: readOnly,
      })}
    >
      <Editor
        ref={editorRef}
        editorState={editorState}
        onChange={onChangeText}
        plugins={plugins}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
        stripPastedStyles
      />
      {/* <MentionSuggestions
        onSearchChange={this.onSearchChange}
        suggestions={suggestions}
        onAddMention={this.onAddMention}
      /> */}
      <EmojiSuggestions />
    </div>
  )
}

export default CommentEditor
